<div class="row">
  <div class="col-4">
    <div class="row justify-content-start">
      <div><i style="color:#ddd" class="fas fa-5x fa-bullseye"></i></div>
      <div style="margin-left:3%;">
        <h4>{{'GLOBAL.NOEUD' | translate | uppercase}}</h4>
        <h4>{{ nomNoeud() }}</h4>
      </div>
    </div>
  </div>
</div>
<div class="row" style="margin-top:2%">
  <ul class="nav nav-tabs not-selectable ps-3" style="width:90%;">
    <li class="nav-item epc-tab">
      <a class="nav-link active">
        {{'GLOBAL.DONNEES_ANALYSE' | translate }}
      </a>
    </li>
  </ul>
</div>
<div class="row display">
  <app-blast-kpi [tabConfigSaisie]="configSaisieSite()" [tabDonneesAnalyse]="donneesAnalyseNoeud()" [inProjetDetail] = "true"
                       [donneesChargees]="initAnalyseFaite()" [typeParent]="TypeParent.Noeud" [projet]="projet()" style="width:90%; height: 100%;">
  </app-blast-kpi>
</div>
